import { render, staticRenderFns } from "./StudentBannedExamination.vue?vue&type=template&id=de9b8cca&"
import script from "./StudentBannedExamination.vue?vue&type=script&lang=js&"
export * from "./StudentBannedExamination.vue?vue&type=script&lang=js&"
import style0 from "./StudentBannedExamination.vue?vue&type=style&index=0&id=de9b8cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports